export default class CACA1110RequestModel {
  productNo: string
  shhnCd: string
}
